/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from "@tanstack/react-router";

import { Route as rootRouteImport } from "./routes/__root";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as ScoutingIndexRouteImport } from "./routes/scouting/index";
import { Route as ScoutingMatchIdRouteRouteImport } from "./routes/scouting/$matchId/route";
import { Route as ScoutingMatchIdReviewRouteImport } from "./routes/scouting/$matchId/review";
import { Route as ScoutingMatchIdEditRouteImport } from "./routes/scouting/$matchId/edit";
import { Route as ScoutingMatchIdCollectRouteRouteImport } from "./routes/scouting/$matchId/collect/route";
import { Route as ScoutingMatchIdCollectIndexRouteImport } from "./routes/scouting/$matchId/collect/index";
import { Route as ScoutingMatchIdCollectTeleopRouteImport } from "./routes/scouting/$matchId/collect/teleop";
import { Route as ScoutingMatchIdCollectPreMatchRouteImport } from "./routes/scouting/$matchId/collect/pre-match";
import { Route as ScoutingMatchIdCollectPostMatchRouteImport } from "./routes/scouting/$matchId/collect/post-match";
import { Route as ScoutingMatchIdCollectEndgameRouteImport } from "./routes/scouting/$matchId/collect/endgame";
import { Route as ScoutingMatchIdCollectAutoRouteImport } from "./routes/scouting/$matchId/collect/auto";

const DebugLazyRouteImport = createFileRoute("/debug")();
const AdminLazyRouteImport = createFileRoute("/admin")();

const DebugLazyRoute = DebugLazyRouteImport.update({
  id: "/debug",
  path: "/debug",
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import("./routes/debug.lazy").then((d) => d.Route));
const AdminLazyRoute = AdminLazyRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import("./routes/admin.lazy").then((d) => d.Route));
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const ScoutingIndexRoute = ScoutingIndexRouteImport.update({
  id: "/scouting/",
  path: "/scouting/",
  getParentRoute: () => rootRouteImport,
} as any);
const ScoutingMatchIdRouteRoute = ScoutingMatchIdRouteRouteImport.update({
  id: "/scouting/$matchId",
  path: "/scouting/$matchId",
  getParentRoute: () => rootRouteImport,
} as any);
const ScoutingMatchIdReviewRoute = ScoutingMatchIdReviewRouteImport.update({
  id: "/review",
  path: "/review",
  getParentRoute: () => ScoutingMatchIdRouteRoute,
} as any);
const ScoutingMatchIdEditRoute = ScoutingMatchIdEditRouteImport.update({
  id: "/edit",
  path: "/edit",
  getParentRoute: () => ScoutingMatchIdRouteRoute,
} as any);
const ScoutingMatchIdCollectRouteRoute =
  ScoutingMatchIdCollectRouteRouteImport.update({
    id: "/collect",
    path: "/collect",
    getParentRoute: () => ScoutingMatchIdRouteRoute,
  } as any);
const ScoutingMatchIdCollectIndexRoute =
  ScoutingMatchIdCollectIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => ScoutingMatchIdCollectRouteRoute,
  } as any);
const ScoutingMatchIdCollectTeleopRoute =
  ScoutingMatchIdCollectTeleopRouteImport.update({
    id: "/teleop",
    path: "/teleop",
    getParentRoute: () => ScoutingMatchIdCollectRouteRoute,
  } as any);
const ScoutingMatchIdCollectPreMatchRoute =
  ScoutingMatchIdCollectPreMatchRouteImport.update({
    id: "/pre-match",
    path: "/pre-match",
    getParentRoute: () => ScoutingMatchIdCollectRouteRoute,
  } as any);
const ScoutingMatchIdCollectPostMatchRoute =
  ScoutingMatchIdCollectPostMatchRouteImport.update({
    id: "/post-match",
    path: "/post-match",
    getParentRoute: () => ScoutingMatchIdCollectRouteRoute,
  } as any);
const ScoutingMatchIdCollectEndgameRoute =
  ScoutingMatchIdCollectEndgameRouteImport.update({
    id: "/endgame",
    path: "/endgame",
    getParentRoute: () => ScoutingMatchIdCollectRouteRoute,
  } as any);
const ScoutingMatchIdCollectAutoRoute =
  ScoutingMatchIdCollectAutoRouteImport.update({
    id: "/auto",
    path: "/auto",
    getParentRoute: () => ScoutingMatchIdCollectRouteRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/admin": typeof AdminLazyRoute;
  "/debug": typeof DebugLazyRoute;
  "/scouting/$matchId": typeof ScoutingMatchIdRouteRouteWithChildren;
  "/scouting/": typeof ScoutingIndexRoute;
  "/scouting/$matchId/collect": typeof ScoutingMatchIdCollectRouteRouteWithChildren;
  "/scouting/$matchId/edit": typeof ScoutingMatchIdEditRoute;
  "/scouting/$matchId/review": typeof ScoutingMatchIdReviewRoute;
  "/scouting/$matchId/collect/auto": typeof ScoutingMatchIdCollectAutoRoute;
  "/scouting/$matchId/collect/endgame": typeof ScoutingMatchIdCollectEndgameRoute;
  "/scouting/$matchId/collect/post-match": typeof ScoutingMatchIdCollectPostMatchRoute;
  "/scouting/$matchId/collect/pre-match": typeof ScoutingMatchIdCollectPreMatchRoute;
  "/scouting/$matchId/collect/teleop": typeof ScoutingMatchIdCollectTeleopRoute;
  "/scouting/$matchId/collect/": typeof ScoutingMatchIdCollectIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/admin": typeof AdminLazyRoute;
  "/debug": typeof DebugLazyRoute;
  "/scouting/$matchId": typeof ScoutingMatchIdRouteRouteWithChildren;
  "/scouting": typeof ScoutingIndexRoute;
  "/scouting/$matchId/edit": typeof ScoutingMatchIdEditRoute;
  "/scouting/$matchId/review": typeof ScoutingMatchIdReviewRoute;
  "/scouting/$matchId/collect/auto": typeof ScoutingMatchIdCollectAutoRoute;
  "/scouting/$matchId/collect/endgame": typeof ScoutingMatchIdCollectEndgameRoute;
  "/scouting/$matchId/collect/post-match": typeof ScoutingMatchIdCollectPostMatchRoute;
  "/scouting/$matchId/collect/pre-match": typeof ScoutingMatchIdCollectPreMatchRoute;
  "/scouting/$matchId/collect/teleop": typeof ScoutingMatchIdCollectTeleopRoute;
  "/scouting/$matchId/collect": typeof ScoutingMatchIdCollectIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/admin": typeof AdminLazyRoute;
  "/debug": typeof DebugLazyRoute;
  "/scouting/$matchId": typeof ScoutingMatchIdRouteRouteWithChildren;
  "/scouting/": typeof ScoutingIndexRoute;
  "/scouting/$matchId/collect": typeof ScoutingMatchIdCollectRouteRouteWithChildren;
  "/scouting/$matchId/edit": typeof ScoutingMatchIdEditRoute;
  "/scouting/$matchId/review": typeof ScoutingMatchIdReviewRoute;
  "/scouting/$matchId/collect/auto": typeof ScoutingMatchIdCollectAutoRoute;
  "/scouting/$matchId/collect/endgame": typeof ScoutingMatchIdCollectEndgameRoute;
  "/scouting/$matchId/collect/post-match": typeof ScoutingMatchIdCollectPostMatchRoute;
  "/scouting/$matchId/collect/pre-match": typeof ScoutingMatchIdCollectPreMatchRoute;
  "/scouting/$matchId/collect/teleop": typeof ScoutingMatchIdCollectTeleopRoute;
  "/scouting/$matchId/collect/": typeof ScoutingMatchIdCollectIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/admin"
    | "/debug"
    | "/scouting/$matchId"
    | "/scouting/"
    | "/scouting/$matchId/collect"
    | "/scouting/$matchId/edit"
    | "/scouting/$matchId/review"
    | "/scouting/$matchId/collect/auto"
    | "/scouting/$matchId/collect/endgame"
    | "/scouting/$matchId/collect/post-match"
    | "/scouting/$matchId/collect/pre-match"
    | "/scouting/$matchId/collect/teleop"
    | "/scouting/$matchId/collect/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/admin"
    | "/debug"
    | "/scouting/$matchId"
    | "/scouting"
    | "/scouting/$matchId/edit"
    | "/scouting/$matchId/review"
    | "/scouting/$matchId/collect/auto"
    | "/scouting/$matchId/collect/endgame"
    | "/scouting/$matchId/collect/post-match"
    | "/scouting/$matchId/collect/pre-match"
    | "/scouting/$matchId/collect/teleop"
    | "/scouting/$matchId/collect";
  id:
    | "__root__"
    | "/"
    | "/admin"
    | "/debug"
    | "/scouting/$matchId"
    | "/scouting/"
    | "/scouting/$matchId/collect"
    | "/scouting/$matchId/edit"
    | "/scouting/$matchId/review"
    | "/scouting/$matchId/collect/auto"
    | "/scouting/$matchId/collect/endgame"
    | "/scouting/$matchId/collect/post-match"
    | "/scouting/$matchId/collect/pre-match"
    | "/scouting/$matchId/collect/teleop"
    | "/scouting/$matchId/collect/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AdminLazyRoute: typeof AdminLazyRoute;
  DebugLazyRoute: typeof DebugLazyRoute;
  ScoutingMatchIdRouteRoute: typeof ScoutingMatchIdRouteRouteWithChildren;
  ScoutingIndexRoute: typeof ScoutingIndexRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/debug": {
      id: "/debug";
      path: "/debug";
      fullPath: "/debug";
      preLoaderRoute: typeof DebugLazyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/admin": {
      id: "/admin";
      path: "/admin";
      fullPath: "/admin";
      preLoaderRoute: typeof AdminLazyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/scouting/": {
      id: "/scouting/";
      path: "/scouting";
      fullPath: "/scouting/";
      preLoaderRoute: typeof ScoutingIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/scouting/$matchId": {
      id: "/scouting/$matchId";
      path: "/scouting/$matchId";
      fullPath: "/scouting/$matchId";
      preLoaderRoute: typeof ScoutingMatchIdRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/scouting/$matchId/review": {
      id: "/scouting/$matchId/review";
      path: "/review";
      fullPath: "/scouting/$matchId/review";
      preLoaderRoute: typeof ScoutingMatchIdReviewRouteImport;
      parentRoute: typeof ScoutingMatchIdRouteRoute;
    };
    "/scouting/$matchId/edit": {
      id: "/scouting/$matchId/edit";
      path: "/edit";
      fullPath: "/scouting/$matchId/edit";
      preLoaderRoute: typeof ScoutingMatchIdEditRouteImport;
      parentRoute: typeof ScoutingMatchIdRouteRoute;
    };
    "/scouting/$matchId/collect": {
      id: "/scouting/$matchId/collect";
      path: "/collect";
      fullPath: "/scouting/$matchId/collect";
      preLoaderRoute: typeof ScoutingMatchIdCollectRouteRouteImport;
      parentRoute: typeof ScoutingMatchIdRouteRoute;
    };
    "/scouting/$matchId/collect/": {
      id: "/scouting/$matchId/collect/";
      path: "/";
      fullPath: "/scouting/$matchId/collect/";
      preLoaderRoute: typeof ScoutingMatchIdCollectIndexRouteImport;
      parentRoute: typeof ScoutingMatchIdCollectRouteRoute;
    };
    "/scouting/$matchId/collect/teleop": {
      id: "/scouting/$matchId/collect/teleop";
      path: "/teleop";
      fullPath: "/scouting/$matchId/collect/teleop";
      preLoaderRoute: typeof ScoutingMatchIdCollectTeleopRouteImport;
      parentRoute: typeof ScoutingMatchIdCollectRouteRoute;
    };
    "/scouting/$matchId/collect/pre-match": {
      id: "/scouting/$matchId/collect/pre-match";
      path: "/pre-match";
      fullPath: "/scouting/$matchId/collect/pre-match";
      preLoaderRoute: typeof ScoutingMatchIdCollectPreMatchRouteImport;
      parentRoute: typeof ScoutingMatchIdCollectRouteRoute;
    };
    "/scouting/$matchId/collect/post-match": {
      id: "/scouting/$matchId/collect/post-match";
      path: "/post-match";
      fullPath: "/scouting/$matchId/collect/post-match";
      preLoaderRoute: typeof ScoutingMatchIdCollectPostMatchRouteImport;
      parentRoute: typeof ScoutingMatchIdCollectRouteRoute;
    };
    "/scouting/$matchId/collect/endgame": {
      id: "/scouting/$matchId/collect/endgame";
      path: "/endgame";
      fullPath: "/scouting/$matchId/collect/endgame";
      preLoaderRoute: typeof ScoutingMatchIdCollectEndgameRouteImport;
      parentRoute: typeof ScoutingMatchIdCollectRouteRoute;
    };
    "/scouting/$matchId/collect/auto": {
      id: "/scouting/$matchId/collect/auto";
      path: "/auto";
      fullPath: "/scouting/$matchId/collect/auto";
      preLoaderRoute: typeof ScoutingMatchIdCollectAutoRouteImport;
      parentRoute: typeof ScoutingMatchIdCollectRouteRoute;
    };
  }
}

interface ScoutingMatchIdCollectRouteRouteChildren {
  ScoutingMatchIdCollectAutoRoute: typeof ScoutingMatchIdCollectAutoRoute;
  ScoutingMatchIdCollectEndgameRoute: typeof ScoutingMatchIdCollectEndgameRoute;
  ScoutingMatchIdCollectPostMatchRoute: typeof ScoutingMatchIdCollectPostMatchRoute;
  ScoutingMatchIdCollectPreMatchRoute: typeof ScoutingMatchIdCollectPreMatchRoute;
  ScoutingMatchIdCollectTeleopRoute: typeof ScoutingMatchIdCollectTeleopRoute;
  ScoutingMatchIdCollectIndexRoute: typeof ScoutingMatchIdCollectIndexRoute;
}

const ScoutingMatchIdCollectRouteRouteChildren: ScoutingMatchIdCollectRouteRouteChildren =
  {
    ScoutingMatchIdCollectAutoRoute: ScoutingMatchIdCollectAutoRoute,
    ScoutingMatchIdCollectEndgameRoute: ScoutingMatchIdCollectEndgameRoute,
    ScoutingMatchIdCollectPostMatchRoute: ScoutingMatchIdCollectPostMatchRoute,
    ScoutingMatchIdCollectPreMatchRoute: ScoutingMatchIdCollectPreMatchRoute,
    ScoutingMatchIdCollectTeleopRoute: ScoutingMatchIdCollectTeleopRoute,
    ScoutingMatchIdCollectIndexRoute: ScoutingMatchIdCollectIndexRoute,
  };

const ScoutingMatchIdCollectRouteRouteWithChildren =
  ScoutingMatchIdCollectRouteRoute._addFileChildren(
    ScoutingMatchIdCollectRouteRouteChildren,
  );

interface ScoutingMatchIdRouteRouteChildren {
  ScoutingMatchIdCollectRouteRoute: typeof ScoutingMatchIdCollectRouteRouteWithChildren;
  ScoutingMatchIdEditRoute: typeof ScoutingMatchIdEditRoute;
  ScoutingMatchIdReviewRoute: typeof ScoutingMatchIdReviewRoute;
}

const ScoutingMatchIdRouteRouteChildren: ScoutingMatchIdRouteRouteChildren = {
  ScoutingMatchIdCollectRouteRoute:
    ScoutingMatchIdCollectRouteRouteWithChildren,
  ScoutingMatchIdEditRoute: ScoutingMatchIdEditRoute,
  ScoutingMatchIdReviewRoute: ScoutingMatchIdReviewRoute,
};

const ScoutingMatchIdRouteRouteWithChildren =
  ScoutingMatchIdRouteRoute._addFileChildren(ScoutingMatchIdRouteRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminLazyRoute: AdminLazyRoute,
  DebugLazyRoute: DebugLazyRoute,
  ScoutingMatchIdRouteRoute: ScoutingMatchIdRouteRouteWithChildren,
  ScoutingIndexRoute: ScoutingIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
